import styled from 'styled-components';

import { IosCta } from './IosCta';
import { AndroidCta } from './AndroidCta';

export const AppCtas = () => (
  <AppCtas.Content data-qa="app_ctas">
    <IosCta />
    <AndroidCta />
  </AppCtas.Content>
);

AppCtas.Content = styled.div`
  display: flex;
  flex-flow: row;
  margin: 24px 0;
  > a:focus {
    outline: none;
  }
`;
